// extracted by mini-css-extract-plugin
export var bubble = "_m-0";
export var container = "_m-f";
export var contrastBorder = "_m-g";
export var greyOut = "_m-2";
export var initialsColor0 = "_m-3";
export var initialsColor1 = "_m-4";
export var initialsColor10 = "_m-d";
export var initialsColor11 = "_m-e";
export var initialsColor2 = "_m-5";
export var initialsColor3 = "_m-6";
export var initialsColor4 = "_m-7";
export var initialsColor5 = "_m-8";
export var initialsColor6 = "_m-9";
export var initialsColor7 = "_m-a";
export var initialsColor8 = "_m-b";
export var initialsColor9 = "_m-c";
export var initialsWrapper = "_m-1";
export var large = "_m-l";
export var medium = "_m-k";
export var mediumSmall = "_m-j";
export var mediumSmallMedium = "_m-o";
export var micro = "_m-h";
export var small = "_m-i";
export var tiny = "_m-n";
export var xTiny = "_m-m";